"use client";

import { useMemo } from "react";
import ReactECharts from "echarts-for-react";

import {
  buildFitCulturelMatchingOption,
  type LigneMatchingFitCulturel,
} from "@repo/fit-culturel";

export type { LigneMatchingFitCulturel };

type Props = {
  lignes: LigneMatchingFitCulturel[];
  /** Hauteur de la pyramide — 7 en fit-culturel. */
  nbNiveaux: number;
  titre?: string;
  hauteur?: string;
};

/**
 * Enveloppe React du radar de matching fit-culturel.
 *
 * La figure elle-même — ses deux couches, sa géométrie, ses couleurs — vit dans
 * `@repo/fit-culturel`, d'où le rapport PDF
 * la tire aussi. Ce fichier ne fait plus que la monter dans la page : tout ce
 * qui se voit doit changer là-bas, sans quoi l'écran et le document divergent.
 */
export function FitCulturelMatchingChart({
  lignes,
  nbNiveaux,
  titre,
  hauteur = "clamp(420px, 62vw, 760px)",
}: Props) {
  const option = useMemo(
    () => buildFitCulturelMatchingOption(lignes, { nbNiveaux, titre }),
    [lignes, nbNiveaux, titre],
  );

  if (lignes.length === 0) {
    return (
      <p className="text-muted-foreground py-8 text-center text-sm">
        Aucun item commun entre ce référentiel et la passation du candidat : rien
        à représenter.
      </p>
    );
  }

  return (
    <ReactECharts
      option={option}
      notMerge
      style={{ width: "100%", height: hauteur }}
    />
  );
}
